import React from 'react'
import PropTypes from 'prop-types'
import { CLEAR_FACEBOOK_ERROR, FACEBOOK_LOGIN_PENDING } from '../../actions'

const withFacebookLogin = (Component) => {
  const wrapped = class extends React.Component {
    loginResponse = (response) => {
      this.props.handleAction(FACEBOOK_LOGIN_PENDING, {
        isRedirectFlow: !!this.props.redirectUri,
        ...response,
      })
    }

    errorHandler = () => {
      if (this.props.facebookError !== '') {
        setTimeout(() => this.props.handleAction(CLEAR_FACEBOOK_ERROR), 30000)
        return this.props.facebookError
      }
      return ''
    }

    render() {
      return (
        <Component
          {...this.props}
          {...this.state}
          facebookLoginResponse={this.loginResponse}
          facebookErrorHandler={this.errorHandler}
        />
      )
    }
  }

  wrapped.propTypes = {
    handleAction: PropTypes.func,
    redirectUri: PropTypes.string,
    facebookError: PropTypes.string,
  }

  wrapped.defaultProps = {
    handleAction: PropTypes.func,
    redirectUri: null,
    facebookError: '',
  }

  return wrapped
}

withFacebookLogin.propTypes = {
  Component: PropTypes.element,
}

withFacebookLogin.defaultProps = {
  Component: PropTypes.element,
}

export default withFacebookLogin



// WEBPACK FOOTER //
// ./src/components/hoc/facebook-login.js